import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { WigTabsComponent } from '@app/wig-tabs/wig-tabs.component';

@Component({
  templateUrl: './wig-tracking.component.html',
  styleUrls: ['./wig-tracking.component.css'],
})
export class WigTrackingComponent implements OnInit {
  @Output() refreshStatsEvent = new EventEmitter<string>();
  @ViewChild('wigtabs') wigTabs: WigTabsComponent;

  driverType: string;
  fleet: string;

  constructor() {}

  ngOnInit() {}

  setDriverType(type: string): void {
    this.driverType = type;
  }

  refreshStatsCall() {
    void this.wigTabs.refreshStats();
  }

  setFleet(fleet: string): void {
    this.fleet = fleet;
  }
}
